module.exports = __webpack_public_path__ + "img/image00008-min.d0b95a7c.jpeg";